/**
 * OneTrust Gate Handler
 *
 * TEMPORARY MODULE - DELETE THIS FILE AFTER ONETRUST CM ROLLOUT IS COMPLETE
 *
 * This module handles the transition period between legacy consent manager
 * and OneTrust consent manager. It queues analytics events until the Statsig
 * gate value is known, preventing server event leaks during OneTrust rollout.
 *
 * To remove after rollout:
 * 1. Delete this file
 * 2. Remove imports of this file
 * 3. Remove OneTrustGateHandler usage from OuraAnalytics
 * 4. Remove setOneTrustGateEnabled calls from React components
 */

interface QueuedEvent {
  method: 'track' | 'page' | 'identify';
  args: unknown[];
}

export class OneTrustGateHandler {
  private isOneTrustGateEnabled: boolean | null = null;
  private eventQueue: QueuedEvent[] = [];

  /**
   * Check if the gate value is known
   */
  isGateKnown(): boolean {
    return this.isOneTrustGateEnabled !== null;
  }

  /**
   * Get the current gate value (false if unknown)
   */
  getGateValue(): boolean {
    return this.isOneTrustGateEnabled ?? false;
  }

  /**
   * Update the gate value from Statsig
   * Returns queued events if this is the first time the gate is set
   */
  setGateValue(enabled: boolean): QueuedEvent[] | null {
    const wasNull = this.isOneTrustGateEnabled === null;
    this.isOneTrustGateEnabled = enabled;

    // Return queued events to be processed
    if (wasNull && this.eventQueue.length > 0) {
      const queue = [...this.eventQueue];
      this.eventQueue = [];
      return queue;
    }

    return null;
  }

  /**
   * Queue an event until gate value is known
   */
  queueEvent(method: QueuedEvent['method'], args: unknown[]): void {
    this.eventQueue.push({ method, args });
  }

  /**
   * Check if events should be queued (gate value unknown)
   */
  shouldQueue(): boolean {
    return this.isOneTrustGateEnabled === null;
  }
}
